export default __webpack_public_path__ + "static/media/activity-tickets-icon.a8725506.svg";